/* Pitstop Pro: express wallets in the MOBILE cart drawer.

   All of this is measured behaviour of Shopify's accelerated-checkout component on the
   live storefront, not assumption:
     - The wallets live in a CLOSED shadow root. host.shadowRoot is null.
     - `display:none` on a wallet blanks it but leaves a hole one slot tall.
     - `order` is ignored completely. order:-5 on PayPal moved it 0px.
     - Removing a wallet from the DOM does NOT compact the rest on mobile. Removing
       Google Pay left PayPal sitting at the same top. The slots are fixed.
     - Reordering by moving nodes does NOT work either. Shopify's slot order is fixed,
       so Shop Pay is always first and that is not controllable from the theme.
     - transform DOES move them, which is the only lever the component leaves open.
     - The host keeps its original height after removals, leaving dead space at the
       bottom (50px with two wallets removed), so its height is clamped too.
     - Shopify picks a HORIZONTAL row layout on cart when few enough wallets fit, and
       iOS Safari did exactly that on an iPhone 15 Plus once only two wallets were
       left. The compaction below assumed a vertical stack, so it translated the second
       button down a line while it kept its horizontal offset: two half-width buttons,
       one left, one right, on separate rows. Two defences now: the container gets
       Shopify's documented additional-checkout-buttons--vertical class on mobile so a
       full-width stack is the layout at every phone size, and compact() refuses to
       touch anything that is not already stacked.

   Therefore: remove the unwanted wallets, then close the holes by measuring where the
   remaining ones actually landed and translating each one up. Everything is measured at
   runtime, so it self-corrects if Shopify changes slot pitch or button height.

   Desktop is untouched. Above 900px the nodes are put back and all inline layout is
   cleared, which lets the theme's own 2x2 grid in cart-drawer.liquid work as designed. */
(function () {
  'use strict';
  var MQ = '(max-width:900px)';
  var GAP = 6;
  var stash = [];
  var pending = null, settle = null;

  function host() {
    return document.querySelector('.ps-drawer .ps-express shopify-accelerated-checkout-cart');
  }
  function container() {
    return document.querySelector('.ps-drawer .ps-express .additional-checkout-buttons');
  }
  function unwanted() {
    // Amazon Pay is off on mobile always. Then exactly one tap-to-pay wallet: the
    // buyer's own. window.ApplePaySession exists only in Safari on Apple hardware, and
    // both wallets rendered together on a real device, so Shopify's own device gating
    // cannot be relied on.
    return ['shopify-amazon-pay-button',
            window.ApplePaySession ? 'shopify-google-pay-button' : 'shopify-apple-pay-button'];
  }
  function visible(h) {
    var out = [];
    for (var i = 0; i < h.children.length; i++) {
      var c = h.children[i], r = c.getBoundingClientRect();
      if (getComputedStyle(c).display !== 'none' && r.height > 0) out.push({ el: c, r: r });
    }
    out.sort(function (a, b) { return a.r.top - b.r.top; });
    return out;
  }
  function clearLayout(h) {
    h.style.removeProperty('height');
    h.style.removeProperty('display');
    for (var i = 0; i < h.children.length; i++) h.children[i].style.removeProperty('transform');
  }
  function compact(h) {
    // Clear our own offsets first so we measure the component's real layout, not ours.
    clearLayout(h);
    var v = visible(h);
    if (!v.length) return;
    // Only ever compact a vertical stack. If Shopify laid the wallets out as a
    // horizontal row, shifting them on Y would push one onto its own line.
    var left0 = Math.round(v[0].r.left);
    for (var i = 0; i < v.length; i++) {
      if (Math.abs(Math.round(v[i].r.left) - left0) > 2) return;
    }
    var top0 = v[0].r.top, want = top0;
    for (var k = 0; k < v.length; k++) {
      var d = want - v[k].r.top;
      // inline !important: the stylesheet carries transform:none!important to defuse
      // the desktop 2x2 grid, and inline !important is what outranks it.
      if (d) v[k].el.style.setProperty('transform', 'translateY(' + d + 'px)', 'important');
      want += v[k].r.height + GAP;
    }
    h.style.setProperty('height', (want - GAP - top0) + 'px', 'important');
    h.style.setProperty('display', 'block', 'important');
  }
  function restore() {
    if (!stash.length) return;
    for (var i = 0; i < stash.length; i++) {
      var s = stash[i];
      if (!s.node.isConnected && s.parent.isConnected) s.parent.appendChild(s.node);
    }
    stash = [];
  }
  function apply() {
    var h = host();
    if (!h) return;
    var c = container();
    if (!window.matchMedia(MQ).matches) {
      if (c) c.classList.remove('additional-checkout-buttons--vertical');
      restore(); clearLayout(h); return;
    }
    // Shopify's documented switch for forcing the vertical stack, so wallets are
    // full width at every phone size instead of flipping to a row on wider phones.
    // https://shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout
    if (c) c.classList.add('additional-checkout-buttons--vertical');
    var list = unwanted();
    for (var i = 0; i < list.length; i++) {
      var el = h.querySelector(list[i]);
      if (el) { stash.push({ node: el, parent: h }); el.remove(); }
    }
    // Let the component finish its own work before measuring, then close the holes.
    clearTimeout(settle);
    settle = setTimeout(function () {
      var hh = host();
      if (hh && window.matchMedia(MQ).matches) compact(hh);
    }, 300);
  }
  function schedule() { clearTimeout(pending); pending = setTimeout(apply, 100); }

  function init() {
    apply();
    // Wallets load asynchronously and the drawer is re-rendered wholesale by the Section
    // Rendering API after every cart change. childList only, so our own style writes
    // cannot retrigger this.
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    var mql = window.matchMedia(MQ);
    if (mql.addEventListener) mql.addEventListener('change', apply);
    else if (mql.addListener) mql.addListener(apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
